import { render, staticRenderFns } from "./DashboardOrderList.vue?vue&type=template&id=2ea496de&"
import script from "./DashboardOrderList.vue?vue&type=script&lang=js&"
export * from "./DashboardOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports